export async function fetchSolDepositAddress(apiBase, walletAddress, authHeaders) {
  const axios = (await import('axios')).default;
  const { data } = await axios.get(`${apiBase}/hyperliquid/unit-deposit-address`, {
    headers: authHeaders(),
    params: { address: walletAddress, asset: 'sol', srcChain: 'solana' },
  });
  return data;
}
